import React, {Component} from 'react';
import Multimedia from './index';
import MultimediaDetalle from './Detalle';
import Utils from '../utils';

class MultimediaData extends Component{
  constructor(){
    super();
    this.state ={
      textPropInt: "new data",
      galeriasSemiarios: [],
      galeriasSemiariosVideos: [],
      galeriasEncuentros: [],
      galeriasEncuentrosVideos: [],
      galeriasEntrevistas: [],
      galeriasMaestrias: []
    }
  }

  componentDidMount(){
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer pat6jAlLNNigrNUEE.b55c43506b2f3705ce219e322d78ae26763b9233d82db88ffeacfab50cf55d98");
    myHeaders.append("Content-Type", "application/json");
    var requestOptions = {
      method: 'GET',
      headers: myHeaders
    };

    fetch("https://api.airtable.com/v0/appwgFjdijimamLnp/Multimedia", requestOptions)
    .then(response=>response.json())
    .then(data=>{
        var gSem = []
        var gSemV = []
        var gEnc = []
        var gEncV = []
        var gEnt = []
        var gMae = []
        data.records.forEach(element => {
          var etiquetas = element.fields.Tags;
          if (etiquetas !== undefined) {
            if (etiquetas.includes("Seminarios")) gSem.push(element);
            if (etiquetas.includes("Seminarios-v")) gSemV.push(element);
            if (etiquetas.includes("Encuentros")) gEnc.push(element);
            if (etiquetas.includes("Encuentros-v")) gEncV.push(element);
            if (etiquetas.includes("Entrevistas")) gEnt.push(element);
            if (etiquetas.includes("Maestrias")) gMae.push(element);  
          }
        });

        gSem = Utils.newestFirst(gSem, "FechaOrganizacional");
        gSemV = Utils.newestFirst(gSemV, "FechaOrganizacional");
        gEnc = Utils.newestFirst(gEnc, "FechaOrganizacional");
        gEncV = Utils.newestFirst(gEncV, "FechaOrganizacional");
        gEnt = Utils.newestFirst(gEnt, "FechaOrganizacional");
        gMae = Utils.newestFirst(gMae, "FechaOrganizacional");

        //Convertimos los watch? de las URLs de youtube a embed
        gSemV.forEach(elem => {
          let url = elem.fields.Videos;
          url = url.replaceAll("watch?v=", "embed/")
          elem.fields.Videos = url;
        });

        gEncV.forEach(elem => {
          let url = elem.fields.Videos;
          url = url.replaceAll("watch?v=", "embed/")
          elem.fields.Videos = url;
        });

        this.setState({
          galeriasSemiarios : gSem,
          galeriasSemiariosVideos : gSemV,
          galeriasEncuentros : gEnc,
          galeriasEncuentrosVideos : gEncV,
          galeriasEntrevistas : gEnt,
          galeriasMaestrias : gMae
        });
    })
    .catch(error=>{
      console.error(error);
    })


  }

  render(){

    let id = this.props.match.params.id;
    if (id && this.state.galeriasSemiarios.length  > 0) {
      
      //tengo que detectar en qué grupo está el id
      // cuando tengo el grupo, pasarseló a multimedia detalle
      let found = false;
      let self = this;
      let gallery = {};
      let title = "";
      let number = 0;

      this.state.galeriasSemiarios.forEach((elem, index) => {
        if (elem.id == id) {
          gallery = self.state.galeriasSemiarios;
          title = self.state.galeriasSemiarios[index].fields.TituloGaleria;
          number = index;
          found = true;          
        }
      })
      
      if (!found) {
        this.state.galeriasSemiariosVideos.forEach((elem, index) => {
          if (elem.id == id) {
            gallery = self.state.galeriasSemiariosVideos;
            title = self.state.galeriasSemiariosVideos[index].fields.TituloGaleria;
            number = index;
            found = true;          
          }
        })  
      }
      
      if (!found) {
        this.state.galeriasEncuentros.forEach((elem, index) => {
          if (elem.id == id) {
            gallery = self.state.galeriasEncuentros;
            title = self.state.galeriasEncuentros[index].fields.TituloGaleria;
            number = index;
            found = true;          
          }
        })  
      }

      if (!found) {
        this.state.galeriasEncuentrosVideos.forEach((elem, index) => {
          if (elem.id == id) {
            gallery = self.state.galeriasEncuentrosVideos;
            title = self.state.galeriasEncuentrosVideos[index].fields.TituloGaleria;
            number = index;
            found = true;          
          }
        })  
      }

      if (!found) {
        this.state.galeriasMaestrias.forEach((elem, index) => {
          if (elem.id == id) {
            gallery = self.state.galeriasMaestrias;
            title = self.state.galeriasMaestrias[index].fields.TituloGaleria;
            number = index;
            found = true;          
          }
        })  
      }

      if (!found) {
        this.state.galeriasEntrevistas.forEach((elem, index) => {
          if (elem.id == id) {
            gallery = self.state.galeriasEntrevistas;
            title = self.state.galeriasEntrevistas[index].fields.TituloGaleria;
            number = index;
            found = true;          
          }
        })  
      }

      let state = { state : {
          title : title,
          gallery : gallery,
          number : number
        }
      }

      //this.props.params.match.id = ""; TO DO borrar el id de la direccion? preguntar

      // Si encontramos la galeria, vamos directo, sino > Multimedia
      if (title) {
        return (
          <div>
            <MultimediaDetalle location={state}/>
          </div>
        )   
      } else {
        window.alert("No pudimos encontrar la galeria. Por favor, revise el vinculo.")
        return (
          <div>
            <Multimedia textPropInt={this.state.textPropInt}
              galeriasMaestrias={this.state.galeriasMaestrias}
              galeriasEncuentros={this.state.galeriasEncuentros}
              galeriasEncuentrosVideos={this.state.galeriasEncuentrosVideos}
              galeriasEntrevistas={this.state.galeriasEntrevistas}
              galeriasSemiarios={this.state.galeriasSemiarios}
              galeriasSemiariosVideos={this.state.galeriasSemiariosVideos}/>
          </div>
        )    
      }

    } else {
      return (
        <div>
          <Multimedia textPropInt={this.state.textPropInt}
            galeriasMaestrias={this.state.galeriasMaestrias}
            galeriasEncuentros={this.state.galeriasEncuentros}
            galeriasEncuentrosVideos={this.state.galeriasEncuentrosVideos}
            galeriasEntrevistas={this.state.galeriasEntrevistas}
            galeriasSemiarios={this.state.galeriasSemiarios}
            galeriasSemiariosVideos={this.state.galeriasSemiariosVideos}/>
        </div>
      )    
    }  
    }
}

export default MultimediaData;
